module.exports = new __parcel__URL__("flag.b309f1bf.svg").toString();